export function maskIPAddress( value ) {
	if ( value ) {
		// remove all non-digits and split string into an array
		const arr = value
			.replace( /[^0-9]/g, '' )
			.split( '' );

		// add "(" at index 0
		// add ")" at index 3
		// add "-" at index 6
		const maskedArr = arr.map( ( char, i ) => {
			switch ( i ) {
				case 3:
					return `.${ char }`;
				case 6:
					return `.${ char }`;
				case 9:
					return `.${ char }`;
				default:
					return char;
			}
		} );

		// join array into a string
		return maskedArr.join( '' );
	}

	return '';
}

export function unmaskIPAddress( value ) {
	if ( value ) {
		// remove all non-digits
		return value.replace( /[^0-9]/g, '' );
	}

	return '';
}
